import React,{ Component, useState, useRef,useEffect } from "react"
//import { createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
//import './ledsend.css'
//import {bgbutton} from "../common/ComUI.js";
import ControlPanel from "../ControlPanel"
import { useProject } from "../Providers"
import style from "../common/setting.module.scss"
import { useForkRef } from "@material-ui/core";
import { useHistory  } from "react-router-dom";
import Radio from "@mui/material/Radio";
//import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';

const iconv = require('iconv-lite');

export default function LedSend() {
    let history = useHistory();
    const { setting, setSetting } = useProject()
    useEffect(() => {
        //getport();
        //OpenReadComPort();
    }, []);

    const [msg, setMsg] = useState("") 
    const [msg1, setMsg1] = useState("") 
    //const [readfiles, setReadFiles] = useState([])
    const readfiles = useRef([]);
    const [filelist, setFilelist] = useState([])
    const [checkedInputs, setCheckedInputs] = useState([]);

    const checkeddatas = useRef([]);
    const imglist = useRef([]);
    const textlist = useRef([]);
    const buslist = useRef([]);

    const send46file = useRef({
        verid:0,
        fileqty:0,
        rqfileidx:0,
        filename:"",
        filesize:0,
        blockqty:0,
        curblockno:0,
        curblocksize:0,
        sendsize:0
    });

    const recv66file = useRef({
        verid:0,
        fileqty:0,
        rqfileidx:0,
        rqblockno:0,
        curblockno:0,
        filegb:0,
        ledgb:0,
    });

    const initSend46file=()=>{
        send46file.current.verid = 0;
        send46file.current.fileqty= 0;
        send46file.current.rqfileidx= 0;
        send46file.current.filename= "";
        send46file.current.filesize= 0;
        send46file.current.blockqty= 0;
        send46file.current.curblockno= 0;
        send46file.current.curblocksize= 0;
        send46file.current.sendsize= 0;
    };

    const initRecv66file = () =>{
        recv66file.current.verid= 0;
        recv66file.current.fileqty= 0;
        recv66file.current.rqfileidx= 0;
        recv66file.current.rqblockno= 0;
        recv66file.current.curblockno= 0;
        recv66file.current.filegb= 0;
        recv66file.current.ledgb= 0;
    };

    const BLOCKSIZE = 256;
    const DTSTART = 8;

    const [portReader, setPortReader] = useState({});
    //const [portWriter, setPortWriter] = useState({});
    const portWriter = useRef(null);
    const rawData = useRef([]);
    const readfileidx = useRef(0);

    const [role, setRole] = useState({});
    const [linkMeasurements, setlinkMeasurements] = useState([]);
    const [timeoutStartInterval, setTimeoutStartInterval] = useState({});
    const [timeoutStopInterval, setTimeoutStopInterval] = useState({});
    const [gatheringInformationInterval, setGatheringInformationInterval] = useState({});
    const [readInformationInterval, setReadInformationInterval] = useState({});

    const connectionLost = useRef(false);
    const peerMessageRcvTimestamp = useRef(0);

    //const [imglist, setImgList] = useState([])
    //const [textlist, setTextList] = useState([])

    const [selecteLed, setSelectedLed] = useState("a");
    const selled = useRef(1);

 
	useEffect(() => {
		if(setting && setting.ledtext ) {
			if(filelist.indexOf(setting.ledtext.filename) < 0) {
				setFilelist([...filelist,setting.ledtext.filename])
				setCheckedInputs([...checkedInputs,setting.ledtext.filename]);
                checkeddatas.current = checkeddatas.current.concat(setting.ledtext.filename);
                //setTextList([...textlist,setting.ledtext]);
                textlist.current = [...textlist.current,setting.ledtext];
			}
			setSetting({
				...setting,
				ledtext: null,
			})
		}
	}, [setting && setting.ledtext? setting.ledtext:null]);	

	useEffect(() => {
		if(setting && setting.screen ) {
			if(filelist.indexOf(`${setting.screen.screenno}.bmp`) < 0) {
				setFilelist([...filelist,`${setting.screen.screenno}.bmp`])
				setCheckedInputs([...checkedInputs, `${setting.screen.screenno}.bmp`]);
                checkeddatas.current = checkeddatas.current.concat(`${setting.screen.screenno}.bmp`);

                //setImgList([...imglist,setting.screen]);
                imglist.current = [...imglist.current, setting.screen]
			}
			setSetting({
				...setting,
				screen: null,
			})
		}
	}, [setting && setting.screen? setting.screen:null]);	

    useEffect(() => {
		if(setting && setting.bus ) {
            if(filelist.indexOf(`${setting.bus.busname}.ebs`) < 0) {
				setFilelist([...filelist,`${setting.bus.busname}.ebs`])
				setCheckedInputs([...checkedInputs, `${setting.bus.busname}.ebs`]);
                checkeddatas.current = checkeddatas.current.concat(`${setting.bus.busname}.ebs`);

                //setImgList([...imglist,setting.screen]);
                buslist.current = [...buslist.current, setting.bus.bus]
			}
			setSetting({
				...setting,
				bus: null,
			})
		}
	}, [setting && setting.bus? setting.bus:null]);	

    const [selp, setSelp] = useState({
        p1 : {id: 1, selected : false, port : {},onClickHandler: selectCom1},
        p2 : {id: 2, selected : false, port : {},onClickHandler: selectCom2},
        supported : false
    })

    async function selectCom1(){
        AskUserForComport(1);
    }
   
    async function selectCom2(){
        AskUserForComport(2)   
    }

    async function readBoard(){
        if(portWriter.current){
            readfileidx.current=0;
            rawData.current = [];
            readfiles.current = [];

            var brd = 0x01;
            if(selecteLed=="b") brd=0x02;
            else if(selecteLed=="c") brd=0x03;
            else if(selecteLed=="d") brd=0x04;
            selled.current = brd;
            getReadFiles(readfileidx.current);   
        }
        else{
           setMsg("Connect Serial Port ...");
        }
    }

    async function sendFiles(){
        if(checkeddatas.current.length == 0 ){
            setMsg1("Select Files in Right Explorer Bar ...");
            return;
        }
        if(portWriter.current){
            rawData.current = [];
            initSend46file();
            initRecv66file();

            var brd = 0x01;
            if(selecteLed=="b") brd=0x02;
            else if(selecteLed=="c") brd=0x03;
            else if(selecteLed=="d") brd=0x04;
            selled.current = brd;

            recv66file.current.fileqty = checkeddatas.current.length;

            sendtoBoard();   
        }
        else{
           setMsg("Connect Serial Port ...");
        }
    }

    async function deleteFiles(file){

        if(portWriter.current){
            rawData.current = [];
   
            var brd = 0x01;
            if(selecteLed=="b") brd=0x02;
            else if(selecteLed=="c") brd=0x03;
            else if(selecteLed=="d") brd=0x04;
            selled.current = brd;

            var crcloc=8+16;
            let data = new Uint8Array(crcloc+6);
            setHeader(data, selled.current ,0x45);

            var filename = file.name.replace(/\u0000/g, "")
            for(let i=0; i<filename.length; i++){
                 data[8+i]=filename.charCodeAt(i); 
            }

            var crc = Make_CRC16ARC(data, crcloc);
            int2Bytes(crc,2, data, crcloc);
            data[crcloc+2] = 0x10; data[crcloc+3] = 0x03; //etx
            
            var ret = deal10( data,  crcloc+4, false);

            try{
                portWriter.current.write(data).then(res=>{
                    console.log("Send 0x45 filelist Command ")
                });
            }catch(e){
                console.log("Send Delete error ")
            }        }
        else{
           setMsg("Connect Serial Port ...");
        }
    }

    function short2Bytes(value){
        let ret = [0x00,0x00];
        // Little Endian
        // ret[0] = (byte) (x);
        // ret[1] = (byte) (x >> 8);

        // Big Endian
        ret[0] = ((value & 0xff00) >> 8);
        ret[1] = (value & 0xff);
        return ret;
    }

    function int2Bytes(value, gb, bytes, start){
        if(gb == 2){
            //let bytes = [0x00,0x00];
            bytes[start] = ((value & 0xff00) >> 8);
            bytes[start+1] = (value & 0xff);
            //bytes.map((c,i)=> (data[start+i]=c));
        }
        else{
            //let bytes = [0x00,0x00,0x00,0x00];
            bytes[start]= ((value & 0xff000000) >> 24);
            bytes[start+1]= ((value & 0x00ff0000) >> 16);
            bytes[start+2]= ((value & 0x0000ff00) >> 8);
            bytes[start+3]= (value & 0x000000ff);
            //bytes.map((c,i)=> (data[start+i]=c));
        }
    }

    function bytes2short(bytes){
        var sign = bytes[0] & (1 << 7);
        var x = (((bytes[0] & 0xFF) << 8) | (bytes[1] & 0xFF));
        if (sign) {
            x = 0xFFFF0000 | x;  // fill in most significant bits with 1's
        }
        return x;
    }

    function getInt64Bytes(x) {
        let y= Math.floor(x/2**32);
        return [y,(y<<8),(y<<16),(y<<24), x,(x<<8),(x<<16),(x<<24)].map(z=> z>>>24)
    }
      
    function intFromBytes(byteArr) {
        return byteArr.reduce((a,c,i)=> a+c*2**(56-i*8),0)
    }

    function setHeader(data,led,op){
       const header =  [0x10, 0x02,0xFF, 0x00,led,0x00,0x53,op];
       header.map((c,i)=> (data[i]=c));
    }

    const Make_CRC16ARC_Table = [
        0x0000, 0xC0C1, 0xC181, 0x0140, 0xC301, 0x03C0, 0x0280, 0xC241, 0xC601, 0x06C0, 0x0780, 0xC741, 0x0500, 0xC5C1, 0xC481,
        0x0440, 0xCC01, 0x0CC0, 0x0D80, 0xCD41, 0x0F00, 0xCFC1, 0xCE81, 0x0E40, 0x0A00, 0xCAC1, 0xCB81, 0x0B40, 0xC901, 0x09C0,
        0x0880, 0xC841, 0xD801, 0x18C0, 0x1980, 0xD941, 0x1B00, 0xDBC1, 0xDA81, 0x1A40, 0x1E00, 0xDEC1, 0xDF81, 0x1F40, 0xDD01,
        0x1DC0, 0x1C80, 0xDC41, 0x1400, 0xD4C1, 0xD581, 0x1540, 0xD701, 0x17C0, 0x1680, 0xD641, 0xD201, 0x12C0, 0x1380, 0xD341,
        0x1100, 0xD1C1, 0xD081, 0x1040, 0xF001, 0x30C0, 0x3180, 0xF141, 0x3300, 0xF3C1, 0xF281, 0x3240, 0x3600, 0xF6C1, 0xF781,
        0x3740, 0xF501, 0x35C0, 0x3480, 0xF441, 0x3C00, 0xFCC1, 0xFD81, 0x3D40, 0xFF01, 0x3FC0, 0x3E80, 0xFE41, 0xFA01, 0x3AC0,
        0x3B80, 0xFB41, 0x3900, 0xF9C1, 0xF881, 0x3840, 0x2800, 0xE8C1, 0xE981, 0x2940, 0xEB01, 0x2BC0, 0x2A80, 0xEA41, 0xEE01,
        0x2EC0, 0x2F80, 0xEF41, 0x2D00, 0xEDC1, 0xEC81, 0x2C40, 0xE401, 0x24C0, 0x2580, 0xE541, 0x2700, 0xE7C1, 0xE681, 0x2640,
        0x2200, 0xE2C1, 0xE381, 0x2340, 0xE101, 0x21C0, 0x2080, 0xE041, 0xA001, 0x60C0, 0x6180, 0xA141, 0x6300, 0xA3C1, 0xA281,
        0x6240, 0x6600, 0xA6C1, 0xA781, 0x6740, 0xA501, 0x65C0, 0x6480, 0xA441, 0x6C00, 0xACC1, 0xAD81, 0x6D40, 0xAF01, 0x6FC0,
        0x6E80, 0xAE41, 0xAA01, 0x6AC0, 0x6B80, 0xAB41, 0x6900, 0xA9C1, 0xA881, 0x6840, 0x7800, 0xB8C1, 0xB981, 0x7940, 0xBB01,
        0x7BC0, 0x7A80, 0xBA41, 0xBE01, 0x7EC0, 0x7F80, 0xBF41, 0x7D00, 0xBDC1, 0xBC81, 0x7C40, 0xB401, 0x74C0, 0x7580, 0xB541,
        0x7700, 0xB7C1, 0xB681, 0x7640, 0x7200, 0xB2C1, 0xB381, 0x7340, 0xB101, 0x71C0, 0x7080, 0xB041, 0x5000, 0x90C1, 0x9181,
        0x5140, 0x9301, 0x53C0, 0x5280, 0x9241, 0x9601, 0x56C0, 0x5780, 0x9741, 0x5500, 0x95C1, 0x9481, 0x5440, 0x9C01, 0x5CC0,
        0x5D80, 0x9D41, 0x5F00, 0x9FC1, 0x9E81, 0x5E40, 0x5A00, 0x9AC1, 0x9B81, 0x5B40, 0x9901, 0x59C0, 0x5880, 0x9841, 0x8801,
        0x48C0, 0x4980, 0x8941, 0x4B00, 0x8BC1, 0x8A81, 0x4A40, 0x4E00, 0x8EC1, 0x8F81, 0x4F40, 0x8D01, 0x4DC0, 0x4C80, 0x8C41,
        0x4400, 0x84C1, 0x8581, 0x4540, 0x8701, 0x47C0, 0x4680, 0x8641, 0x8201, 0x42C0, 0x4380, 0x8341, 0x4100, 0x81C1, 0x8081,
        0x4040 
    ];

    function Make_CRC16ARC(data,len)
    {
		var res = 0x0000;
		for (let i=2; i<len; i++) {
			res = (res >> 8) ^ Make_CRC16ARC_Table[(res ^ data[i]) & 0xff];
		}
		return res;
    }

    function getReadFiles(index){ //0x4C
        let len = 14;
        if(index==0x10) len +=1;
        let data = new Uint8Array(len);
        setHeader(data, selled.current ,0x4C);
        var ret = short2Bytes(index);
        data[8]=ret[0];
        data[9]=ret[1];
        if(index==0x10) data[10] = 0x10;
        //data = deal10(data,  false);
        var crc = Make_CRC16ARC(data, len-((index==0x10)?5:4));
        let arr = short2Bytes(crc);
     
        data[len-4]=arr[0];
        data[len-3]=arr[1];
        data[len-2]=0x10;
        data[len-1]=0x03;

        if(portWriter){
            try{
                portWriter.current.write(data).then(res=>{
                    console.log("Send 0x4C filelist Command ")
                });
            }catch(e){
                console.log("Send 0x4C error ")
            }
        }
    }

    const getBusBuffer = (bus) => {
		let date = new Date();
		let filename = bus.led + bus.busno + bus.dir; //파일명
		let bytes = new Uint8Array(1024);
		for(let i=0; i<filename.length; i++) bytes[i]=filename.charCodeAt(i) 
		let str1 = bus.led + bus.busid + bus.dir; //파일명
		for(let i=0; i<str1.length; i++) bytes[i+0x10]=str1.charCodeAt(i)  
		bytes[0x20] = Number('0x'+date.getFullYear().toString().substring(2,4)); //날짜
		bytes[0x21] = Number('0x'+date.getMonth().toString().padStart(2, '0')); 
		bytes[0x22] = Number('0x'+date.getDate().toString().padStart(2, '0')); 
		bytes[0x23] = Number('0x'+date.getHours().toString().padStart(2, '0')); 
		bytes[0x24] = Number('0x'+date.getMinutes().toString().padStart(2, '0')); 
		bytes[0x25] = Number('0x'+date.getSeconds().toString().padStart(2, '0')); 
		for(let i=0; i<4; i++) bytes[i+0x26]= 0xFF;
		bytes[0x2B]= 0x01;	bytes[0x41]= 0x48;	bytes[0x43]= 0x1E;	bytes[0x48]= 0x44;	bytes[0x49]= 0x45; //고정
		bytes[0x2B]=bytes[0x2B]=0x01;
		const decbusname = iconv.encode(bus.busno, 'euc-kr');
		for(let i=0; i<decbusname.length; i++) bytes[i+0x4C]=decbusname[i]//버스번호
		const decstartname = iconv.encode(bus.startname, 'euc-kr');
		for(let i=0; i<decstartname.length; i++) bytes[i+0x6C]=decstartname[i]//출발지
		const decendname = iconv.encode(bus.endname, 'euc-kr');
		for(let i=0; i<decendname.length; i++) bytes[i+0x8C]=decendname[i]//도착지

		for(let i=0; i<bus.starteng.length; i++) bytes[i+0xAC]=bus.starteng.charCodeAt(i)//출발지 eng
		for(let i=0; i<bus.endeng.length; i++) bytes[i+0xCC]=bus.endeng.charCodeAt(i)//도착지 eng

		const decviastopnames = iconv.encode(bus.via, 'euc-kr');
		for(let i=0; i<decviastopnames.length; i++) bytes[i+0xEC]=decviastopnames[i]//경유지

		for(let i=0; i<bus.viaeng.length; i++) bytes[i+0x1AC]= bus.viaeng.charCodeAt(i)//경유지 eng
		const resid1 = iconv.encode(bus.res1, 'euc-kr');
		for(let i=0; i<resid1.length; i++) bytes[i+0x26C]= resid1[i]//res1
		const resid2 = iconv.encode(bus.res2, 'euc-kr');
		for(let i=0; i<resid2.length; i++) bytes[i+0x28C]= resid2[i]//res2
		bytes[0x2AC] = 0x0D; bytes[0x2AD]=0x0A; 
        
        return bytes;
	}

    function sendtoBoard(){ //0x46

        rawData.current = [];

        if(recv66file.current.rqfileidx >= checkeddatas.current.length ) return;
        var file = checkeddatas.current[recv66file.current.rqfileidx];

        setTimeout(() => setMsg1(`sending ${file}  ${send46file.current.curblockno+1}/${send46file.current.blockqty}`), 5);

        let orgbuf = null;
        var img = imglist.current.find( img=> (`${img.screenno}.bmp`==file) )
        if( img){
            //orgbuf = Buffer.from( img.bmpbuf, 'base64');
            orgbuf = btoa( img.bmpbuf);
            send46file.current.filesize = orgbuf.length;
        }
        else{
            var txt = textlist.current.find( t=> (t.filename==file) )
            if( txt){
                //orgbuf = Buffer.from( txt.ledtext, 'base64');
                orgbuf = btoa(txt.ledtext);
                send46file.current.filesize = orgbuf.length;
            }
            else{

                var bus = buslist.current.find( t=> (`${t.busname}.ebs`==file) )
                //orgbuf = Buffer.from( getBusBuffer(bus), 'base64');
                orgbuf = btoa(getBusBuffer(bus));
                send46file.current.filesize = orgbuf.length;
                return;
            }
        }

        // QString sendFileloc = sendFileList[recv66file.current.rqfileidx];
        // QString fname = sendFileloc.section("/",-1);

        if(send46file.current.filesize == 0 || recv66file.current.curblockno == 0){
            //send46file.current.filesize = getFilesize(sendFileloc);
            if(send46file.current.filesize >  0){
                send46file.current.blockqty = send46file.current.filesize / BLOCKSIZE;
                if( send46file.current.blockqty * BLOCKSIZE < send46file.current.filesize ) send46file.current.blockqty++;
                send46file.current.curblockno = 0;
                send46file.current.curblocksize = (send46file.current.filesize > BLOCKSIZE)? BLOCKSIZE:send46file.current.filesize;
                send46file.current.rqfileidx = recv66file.current.rqfileidx;
            }
        }
        else if( recv66file.current.curblockno  < send46file.current.blockqty){
            send46file.current.curblocksize = (send46file.current.filesize - (recv66file.current.curblockno*BLOCKSIZE) >= BLOCKSIZE)?
                        BLOCKSIZE : send46file.current.filesize - ( recv66file.current.curblockno)*BLOCKSIZE;
            send46file.current.curblockno = recv66file.current.curblockno;

        }
        else return;

        if(send46file.current.curblocksize > 0 )
        {
            let ntotal = DTSTART+ 8 + send46file.current.curblocksize + 4 + 4; 
            let send_232buf = new Uint8Array(ntotal);
            setHeader(send_232buf, selled.current ,0x46);

            int2Bytes(send46file.current.filesize,4, send_232buf, DTSTART );
            int2Bytes(send46file.current.curblocksize,2,send_232buf,DTSTART+4);
            int2Bytes(send46file.current.curblockno,2, send_232buf,DTSTART+6);

            for(var x=0; x<send46file.current.curblocksize; x++)
                send_232buf[DTSTART+8+x] = orgbuf[(send46file.current.curblockno)*BLOCKSIZE + x];

            const crcloc = DTSTART+8+ send46file.current.curblocksize;
            var crc = Make_CRC16ARC(send_232buf, crcloc);
            int2Bytes(crc,2, send_232buf, crcloc);
            send_232buf[crcloc+2] = 0x10; send_232buf[crcloc+3] = 0x03; //etx
            send46file.current.sendsize = crcloc+4;
            var ret = deal10(send_232buf,  send46file.current.sendsize, false);

            //var debugstr = '';
            //send_232buf.map(c=> {debugstr += c.toString(16).padStart(2,'0'); debugstr+=" ";}); 

            if(portWriter){
                try{
                    portWriter.current.write(send_232buf).then(res=>{
                        console.log("Send 0x4C filelist Command ")
                    });
                }catch(e){
                    console.log("Send 0x4C error ")
                }
            }
        }
    }

    function deal10(buffer, size, bdel)
    {
        var ret = size;
        if(bdel){
            for(var i=0; i<ret; i++){
                if(buffer[i]==0x10 && buffer[i+1]==0x10){
                    //memcpy(buffer+i+1, buffer+i+2, ret-i);
                    buffer.splice(i, 1)
                    i++;
                    ret--;
                }
            }
        }
        else{
            for(var i=2; i<ret-2; i++){
                if(buffer[i]==0x10 ){ 
                    //memcpy(buffer+i+2, buffer+i+1, ret-i+1);
                    //buffer[i+1]=0x10;
                    //buffer.splice( i,0,0x10)

                    for(var x =ret; x > i;x--) buffer[x] = buffer[x-1];
                    buffer[i+1] = 0x10;
                    i++;
                    ret++;
                }

                if(ret >= buffer.length) break;
            }
        }
        return ret;
    }

    const convertHashToHex = (value) => {
        return value.map(v => v.toString(16).padStart(2, '0')).join('');
     } 

    function ProcessRawData(){
        var iPos = 0;
        const recv_232buf = rawData.current;
        const imax = recv_232buf.length - 8;
        while( iPos < imax){

            if ( ( recv_232buf[iPos]==0x10 ) && ( recv_232buf[iPos+1]==0x02 ) && ( recv_232buf[iPos+2]==0xff ) )
            {
                const devid = recv_232buf[iPos+4];
                const opState = recv_232buf[iPos+6];
                const opCode = recv_232buf[iPos+7];
                peerMessageRcvTimestamp.current = Date.now();
                var packetLen = 0;

                if ( opCode==0x66 ) {  //파일전송응답
                    var packetLen = DTSTART + 3 + 4;
                    var res = recv_232buf[iPos+8];
                    var nextframe = ( recv_232buf[iPos+9] << 8 ) + ( recv_232buf[iPos+10] );

                    if(res == 0x53){
                        if(nextframe < send46file.current.blockqty ){
                            recv66file.current.curblockno = nextframe;

                            sendtoBoard();   

                            if(recv66file.current.rqfileidx+1 == recv66file.current.fileqty && 
                                recv66file.current.curblockno+1 == send46file.current.blockqty){
                                setMsg("Sending File Complete..")
                    
                                //oldVersion = QString::number(recv66file.verid);
                                      // if(recv66file.filegb == 1){ //fw
                                //     QString sendFileloc = sendFileList[recv66file.rqfileidx];
                                //     QString fname = sendFileloc.section("/",-1);
                                //     int loc = 1;
                                    
                                //     if(fname.at(0)=='S') loc = 2;
                                //     else if(fname.at(0)=='B') loc = 3;
                                //     else if(fname.at(0)=='I') loc = 4;
                                //     saveDatabase(recv66file,  (recv66file.filegb == 1)?4:2, loc);
                                // }
                                // else
                                //     saveDatabase(recv66file,  (recv66file.filegb == 1)?4:2);
                            }
                        }
                        else{
                            if(recv66file.current.rqfileidx < recv66file.current.fileqty && recv66file.current.filegb == 1){ //fw
                                // QString sendFileloc = sendFileList[recv66file.rqfileidx];
                                // QString fname = sendFileloc.section("/",-1);
                                // int loc = 1;
                                // if(fname.at(0)=='S') loc = 2;
                                // else if(fname.at(0)=='B') loc = 3;
                                // else if(fname.at(0)=='I') loc = 4;
                                // saveDatabase(recv66file,  (recv66file.filegb == 1)?4:2, loc);
                            }
      
                            if(++recv66file.current.rqfileidx < recv66file.current.fileqty){
                                recv66file.current.curblockno=0;
                                sendtoBoard(); 
                            }
                            else{
                                setMsg("Sending File Complete..")
                                rawData.current = [];
                                initSend46file();
                                initRecv66file();
                                //qDebug() <<recv66file.rqfileidx << recv66file.fileqty << "end";
                                //if(recv66file.filegb == 0 && recv66file.fileqty > 0) saveDatabase(recv66file,  (recv66file.filegb == 1)?4:2);
                            }
                        }
                    }
                }
                else if (opState ==0x53 && opCode==0x6C ) { //파일목록응답
                    const size6c = 27;

                    if(size6c > imax-iPos ) break;

                    packetLen = size6c + 8;
                    let recv6Cfile = recv_232buf.slice(iPos+8,iPos+8+size6c);
                    deal10(recv6Cfile, recv6Cfile.length,  true);
     
                    if(recv6Cfile[1] == 0x00 ){
                        let uint8Arr = new Uint8Array(recv6Cfile.slice(2,18));
                        let name = new TextDecoder("utf-8").decode(uint8Arr);
                        name = name.substring(0,10);//name.replace(/\s/g, "");
                        let date = convertHashToHex(recv6Cfile.slice(19,25));
                        let size = recv6Cfile[25];//bytes2short(recv6Cfile.slice(25,27));

                        readfiles.current = readfiles.current.concat({name:name, date: String(date).substring(0,8), size:size });
                        setMsg(`Received File : ${name} ${readfiles.current.length}EA`);
                        //readfiles.current.concat( `${name} ${date} ${size}`);
                        // setReadFiles([...readfiles,{name:name.replace(/\s/g, ""),
                        //     date:date, size:size,
                        // }]);

                        if(readfileidx.current<255){
                            rawData.current = rawData.current.slice(iPos + packetLen);
                            readfileidx.current += 1;
                            getReadFiles(readfileidx.current); 
                        }
                    }
                    else{ //} if(recv6Cfile[1] == 'E' ){
                        if(readfileidx.current<255){
                            getReadFiles(readfileidx.current); 
                        }
                    }
                }
                else if (opState ==0x53 && opCode==0x65 ) { //파일 삭제
                    var state = recv_232buf[iPos+8];
                    var opMode = recv_232buf[iPos+9];
                    setMsg("File Deleted");
                }

                iPos = iPos + packetLen;
                if ( imax > iPos ) {
                    // syslog(LOG_INFO, "More");
                } else {
                    break;
                }
            }
            iPos++;
        }

        // let commandArray = rawData.current.split('*')
        // if(commandArray.length>1){
        //     commandArray.forEach(item=>{
        //         //ProcessSplittedCommand(item)
        //         peerMessageRcvTimestamp.current = Date.now()
        //         console.log("Raw data " ,item)
        //     })
        //     rawData = commandArray[commandArray.length-1]
        // }
    }

    async function ReadValues(pReader){
        for(;;)
        {
            try{
                if(!connectionLost.current){
                    const { value, done } = await pReader.read();
                    if(value){
                        connectionLost.current = false
                        //rawData.current += new TextDecoder("utf-8").decode(value);
                        //rawData.current = rawData.current.concat(value);
                        value.map(c=> rawData.current.splice(rawData.current.length,0,c));
                        ProcessRawData()
                    }
                    if (done) {
                        // 나중에 시리얼 포트가 닫힐 수 있도록 해준다.
                        connectionLost.current = true;
                        pReader.releaseLock();
                        break;
                    }
                }
                else{
                    break;
                }
            }
            catch(err){
                setMsg("Retry ...");
                console.error("READ VALUES ERROR " ,err)
                connectionLost.current = true
                //pevStrings[17].found = true;

               break
            }
        }

        /*
        portReader.read().then(res=>{
            rawData += new TextDecoder("utf-8").decode(res.value);
            return rawData;
            // setTimeout(ProcessRawData(),0);
            // ReadValues();
        }).then(val=>{
            ProcessRawData()
            ReadValues()
        })
        */
    }

    async function CloseComPort(){
        if(selp.p1.selected && selp.p1.port){
            try{
                connectionLost.current = true;
                clearInterval( gatheringInformationInterval );
                //clearInterval(readInformationInterval);
                selp.p1.port.close();
                setSelp(
                    {
                        p1 : {id: selp.p1.id, selected : false, port : null},
                        p2 : selp.p2,
                        supported : selp.supported
                    }
                )
                setMsg("Serial Disconnected");
                window.location.reload();
            }
            catch(e){
                setMsg("Serial Disconnected");
            }
        }
    }

    async function OpenReadComPort(p_Port){
        console.log("OpenReadComPort | begin")

        try{
            await p_Port.open({ baudRate: 38400});
        }catch(e){
            p_Port.close();
            setSelp(
                {
                    p1 : {id: selp.p1.id, selected : false, port : null},
                    p2 : selp.p2,
                    supported : selp.supported
                }
            )
            setMsg("Serial Connect Fail Retry...");
            return;
        }

        setMsg("Serial Connected");
         
        try{
            var portReader = p_Port.readable.getReader();
            setPortReader(portReader);
            portWriter.current = p_Port.writable.getWriter();
            //setPortReader(portWriter);

            //const readInformationInterval = setInterval(() => { 
            setTimeout(()=>{
                ReadValues(portReader)
            },0)
            //setReadInformationInterval(readInformationInterval);

            const gatheringInformationInterval = setInterval(() => { 
                if(connectionLost.current)
                    return

                // const data = new Uint8Array([114]); // r
                // portWriter.write(data).then(res=>{
                //     console.log("Send Information Command ",res)
                // });

                // const millis = Date.now() - peerMessageRcvTimestamp.current
                // if(millis > 6000 || (state.evseDeviceState === -1 && state.evseHpgState === -1)){
                //     console.error("Connection lost to EVSE")
                //     //initializePEVStrings()
                //     pevStrings[16].found = true;

                // }
            },2000);

            setGatheringInformationInterval(gatheringInformationInterval);
        }catch(e){
            //p_Port.close();
            setSelp(
                {
                    p1 : {id: selp.p1.id, selected : false, port : null},
                    p2 : selp.p2,
                    supported : selp.supported
                }
            )
            setMsg("Serial Connect Fail");
            //alert("Serial Connect Fail");
            //window.location.reload();
            //history.push("/ledtext");
        }

        console.log("OpenReadComPort | end")
    }

    const [pevStrings, setPevStrings] = useState(
        [
            {details : "TIMEOUT",display : "Timeout Occured",found : false,warning : "red",blink : false},	
            {details : "TIMEOUT FOR CONNECT",display : "Timeout To Reconnect",found : false,warning : "red",blink : false},	
            {details : "Waiting for EVSE to be ready!",display : "Waiting for EVSE to be ready!",found : false,warning : "false",blink : false},
            {details : "wrong protocol for pev",display : "Wrong protocol is detected on PEV side",found : false,warning : "red",blink : true},	
            {details : "wrong protocol for evse",display : "Wrong protocol is detected on EVSE side",found : false,warning : "red",blink : true},
            {details : "System is not completed, Power ON Evse Simulator",display : "System is not completed, Power ON Evse Simulator",found : false,warning : "red",blink : true},	
        ]
    );
    

    async function AskUserForComport(slotId){

        const portList = await navigator.serial.getPorts()
        // if(portList.length === 1){
        //     setSelp(
        //         {
        //         p1 : {id: selp.p1.id, selected : true, port :  portList[0]},
        //         p2 : selp.p2,
        //         supported : selp.supported
        //         }
        //     )
        //     OpenReadComPort(portList[0]);
        // }
        // else
        {
            try {
            switch(slotId){
            case 1:
                if( !selp.p1  || selp.p1.selected  === false ){
                console.log("list of serial ports the website has been granted access to previously",navigator.serial.getPorts())
                const p1 = await navigator.serial.requestPort()
                console.log("AskUserForComport p1",p1)

                if(p1){
                    setSelp(
                        {
                        p1 : {id: selp.p1.id, selected : true, port : p1},
                        p2 : selp.p2,
                        supported : selp.supported
                        }
                    )
                    OpenReadComPort(p1);
                }   
                return p1; 
                }
                break;
        
                case 2:
                    if( !selp.p2  || selp.p2.selected  === false){
                    const p2 = await navigator.serial.requestPort()
                    
                    setSelp(
                        {
                        p1 : selp.p1,
                        p2 : {id: selp.p2.id, selected : true, port : p2},
                        supported : selp.supported
                        }
                    )
            
                    }
                    break;
                    default:
                    console.error("Default switch-case")
                    break;
                }
            } catch (err) {
                console.log("An error was caught: ", err);
            }
        }
    }

    const changeHandler = (e) =>{
		if (e.currentTarget.checked) {
		  setCheckedInputs([...checkedInputs, e.target.id]);
          checkeddatas.current = [...checkeddatas.current, e.target.id];
		} else {
		  setCheckedInputs(checkedInputs.filter((el) => el !== e.target.id));
          checkeddatas.current = checkeddatas.current.filter((el) => el !== e.target.id);
		}
	};

    function FilelistRow({key,filename}) {
		return (
			<div key={key} style={{width:'310px'}}>
				<input 
                    className={style.input}
                    style={{marginRight:'-30px',marginLeft:'-30px'}}
                    id={filename} type="checkbox"
					onChange={changeHandler}
					checked={checkeddatas.current.includes(filename) ? true : false}/>
                <span>{filename}</span>
			</div>		    
		); 
	};	

    function ReadFileRow({key,file}) {
		return (
			<div key={key} style={{width:'310px'}}>
                <span style={{marginRight:'5px'}}>{file.name}</span>
                <span style={{marginRight:'30px'}}>{file.date}</span>
                <span>{file.size}</span>
                <IconButton style={{marginLeft:'20px',width:'22px',height:'22px',marginTop:'-5px'}}
                     onClick={() => deleteFiles(file)}>
                    <ClearSharpIcon />
                </IconButton>
                {/* <button className={style.span} style={{marginLeft:'10px'}} onClick={deleteFiles}>x</button> */}
			</div>		
		); 
	};	

    const handleChange = (e) =>{
        setSelectedLed(e.target.value);
	}

    return (
        <div className = {style.defaultModal} style={{ display: 'flex', flexDirection:'row',marginLeft:'10px', marginTop: '50px'}}>
        <div style={{  flex: '16%', width: '300px'}}>
            <div style={{marginBottom:'20px'}}>
            <button className={style.button} onClick={selectCom1}>Connect Serial</button>
            </div>
            <span className = {style.nocs} >Select LED</span> 
            <div style={{marginTop:'20px'}}>
                <span className = {style.span} >FRONT</span> 
                <Radio
                    checked={selecteLed === "a"}
                    onChange={handleChange}
                    value="a"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "A" }}
                    style={{color:'#2DE0DD'}}
                />
            </div>
            <div>
                <span className = {style.span} > SIDE &nbsp;&nbsp;</span> 
                <Radio
                    checked={selecteLed === "b"}
                    onChange={handleChange}
                    value="b"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "B" }}
                    style={{color:'#2DE0DD'}}
                />
            </div>
            <div>
            <span className = {style.span} > BACK &nbsp;</span> 
            <Radio
                checked={selecteLed === "c"}
                onChange={handleChange}
                value="c"
                name="radio-buttons"
                inputProps={{ "aria-label": "C" }}
                style={{color:'#2DE0DD'}}
            />
            </div>
            <div>
            <span className = {style.span} >INSIDE</span> 
            <Radio
                checked={selecteLed === "d"}
                onChange={handleChange}
                value="d"
                name="radio-buttons"
                inputProps={{ "aria-label": "D" }}
                style={{color:'#2DE0DD'}}
            />
            </div>
        </div>
        <div style={{  flex: '22%',  marginLeft:'20px'}}>	
            <div style={{marginBottom:'20px'}}>
                {/* <span className = {style.span} >Serial Connect</span> */}
                {/* <button className={style.button} onClick={CloseComPort}>Disconnect</button> */}
                <button className={style.button} onClick={readBoard}>Read Board Files</button>
            </div>
            { (selp.p1.selected && selp.p1.port)?
                <span className={style.cs}>Board Files</span>:
                <span className = {style.nocs}>Board Files</span>
            }
                <div className= {style.wrapper}>
                    <span style={{color:'#C3602C',fontWeight:'600'}}>Filename &nbsp;&nbsp;&nbsp;&nbsp;  Version &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Size</span>
                    {readfiles.current && readfiles.current.length > 0 && 
                        readfiles.current.map((file, i) => (
                            <ReadFileRow key={i+1000}
                                file={file}
                            />
                    ))}
                </div>
                <label className={style.label} style={{ color:"#C3602C", marginTop:"10px"}} value={msg}>{msg}</label>
        </div>
		<div style={{  flex: '22%',  marginLeft:'40px'}}>	
            <div style={{marginBottom:'20px'}}>
                {/* <span className = {style.span} >Serial Connect</span> */}
                {/* <button className={style.button} onClick={selectCom1}>Serial Connect</button> */}
                <button className={style.button} onClick={sendFiles}>Send Files</button>
                {/* <button className={style.button} onClick={CloseComPort}>Disconnect</button> */}
            </div>
            { (selp.p1.selected && selp.p1.port)?
                <span className={style.cs}>Send Files</span>:
                <span className = {style.nocs}>Send Files</span>
            }
                <br></br>
                <div className= {style.wrapper}>
                    {filelist && filelist.length > 0 && filelist.map((filename, i) => (
							<FilelistRow key={i} filename={filename} />
					))}
                </div>
                <label className={style.label} style={{ color:"#C3602C", marginTop:"10px"}} value={msg1} >{msg1}</label>
	    </div>
        <div style={{  flex: '40%', marginLeft:'20px'}}>	
            <span className={style.nocs} style={{ marginLeft:'31%'}}>
                Select Files to Send</span>
            {<ControlPanel menu="send" />}
        </div>
        </div>
    );

}
